import { Box, Button, Text, Icon } from "@chakra-ui/react";
import React from "react";
import { MdMessage, MdLockOpen } from "react-icons/md";
import useAxios from "axios-hooks";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { activeConnectorState } from "atoms/activeConnectorState";
import { toastState } from "atoms/toastState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";

const UnlockConnector = ({ refresh, connector: connectorProp, compact = false }) => {
  const activeConnectorFromState = useRecoilValue(activeConnectorState);
  const activeConnector = connectorProp ?? activeConnectorFromState;

  const setToast = useSetRecoilState(toastState);
  const [{ data, loading, error }, execute] = useAxios(
    { method: "POST", url: "/api/ocpp16/unlockConnector" },
    { manual: true }
  );

  const operation = async () => {
    let body = {};
    body["EvseSerialId"] = activeConnector.EvseSerialId;
    body["StationId"] = activeConnector.EvseId;
    try {
      const response = await execute({ data: body });
      setToast({
        isOpen: true,
        title: "Connector Unlocked Successfully",
        description: response.data.data.Message,
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      logger.log(error);
      setToast({
        isOpen: true,
        title: "Error occured when Unlocking",
        description: err ? err : null,
        status: "error",
      });
    }
    refresh();
  };
  if (compact) {
    return (
      <Button
        w="100%"
        borderRadius="lg"
        bg="rgba(245, 125, 54, 0.08)"
        color="#f57d36"
        border="1px solid rgba(245, 125, 54, 0.28)"
        leftIcon={<Icon as={MdLockOpen} boxSize={{ base: 3, md: 3.5 }} />}
        _hover={{
          bg: "rgba(245, 125, 54, 0.15)",
          borderColor: "rgba(245, 125, 54, 0.5)",
          transform: "translateY(-1px)",
          boxShadow: "0 4px 12px rgba(245, 125, 54, 0.18)",
        }}
        _active={{ bg: "rgba(245, 125, 54, 0.2)", transform: "translateY(0)" }}
        transition="all 0.2s ease"
        h={{ base: "28px", md: "32px" }}
        fontWeight="600"
        fontSize="xs"
        letterSpacing="0.3px"
        px={{ base: 1.5, md: 3 }}
        onClick={operation}
        isLoading={loading}
        overflow="hidden"
        minW={0}
      >
        <Box as="span" display={{ base: "none", md: "inline" }}>Unlock</Box>
      </Button>
    );
  }

  return loading ? (
    <LoadingSpinner />
  ) : (
    <Card alignItems="stretch" pt={0} px={0} pb={0}>
      <Text fontWeight={700} fontSize="sm" color="gray.700" mb={2.5}>
        Unlock Connector
      </Text>
      <Button
        alignSelf="flex-end"
        borderRadius="md"
        size="sm"
        h="36px"
        fontSize="sm"
        textColor={"white"}
        backgroundColor="#f57d36"
        _hover={{ backgroundColor: "whatsapp.600" }}
        rightIcon={<MdMessage size={13} />}
        onClick={operation}
        isLoading={loading}
      >
        Send Message
      </Button>
    </Card>
  );
};

export default UnlockConnector;
